// extracted by mini-css-extract-plugin
export var divider = "_3b-0";
export var dividerText = "_3b-2";
export var dividerVertical = "_3b-1";